import { helpers, type PluginConfiguration } from '../helpers'
import { icons } from '../icons'

export const cleaner: PluginConfiguration = {
  name: 'Cleaner',
  id: 'cleaner',
  icon: icons.cleaner,
  extra: '',
  layout: {
    type: 'full',
    render: () => {
      const createdElements = helpers.createHTMLElements([
        {
          className:
            'pt-4 px-4 flex items-center justify-between mb-2 text-white gap-2 font-semibold',
          content: 'Cleaner',
        },
        {
          className: 'flex flex-col xl:flex-row gap-4 p-4',
          content: () =>
            helpers.createHTMLElements([
              {
                className:
                  'focus:scale-98 flex flex-1 justify-center border-0 text-white! transition-all bg-[#4a5565] hover:bg-[#364153]! rounded-md cursor-pointer p-2',
                content: 'Clear everything',
                title: 'Deleting session storage, local storage and cookies',
                id: 'fu-tools-cleaner-clear-all',
              },
              {
                className:
                  'focus:scale-98 flex flex-1 justify-center border-0 text-white! transition-all bg-[#4a5565] hover:bg-[#364153]! rounded-md cursor-pointer p-2',
                content: 'Clear everything except authorization',
                title: "Deleting everything except storage items with key - 'jwt' and 'region'",
                id: 'fu-tools-cleaner-clear-without-auth',
              },
            ]),
        },
      ])

      const tempDiv = document.createElement('div')
      tempDiv.appendChild(createdElements)
      return tempDiv.outerHTML
    },
  },
  init: () => {
    const clearAllButton = document.querySelector('#fu-tools-cleaner-clear-all')
    const clearWithoutAuthButton = document.querySelector('#fu-tools-cleaner-clear-without-auth')

    const clearCookies = () => {
      document.cookie.split(';').forEach(cookie => {
        const cookieName = cookie.split('=')[0]
        // biome-ignore lint/suspicious/noDocumentCookie: Intentionally clearing cookies in devtools
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      })
    }

    clearAllButton?.addEventListener('click', () => {
      sessionStorage.clear()
      localStorage.clear()
      clearCookies()
    })

    clearWithoutAuthButton?.addEventListener('click', () => {
      const doNotDeleteKeys = ['jwt', 'region']

      const keys = [...Object.keys(sessionStorage), ...Object.keys(localStorage)]
      keys.forEach(key => {
        if (doNotDeleteKeys.includes(key)) {
          return
        }

        sessionStorage.removeItem(key)
        localStorage.removeItem(key)
      })
      clearCookies()
    })
  },
  render: () => cleaner.layout.render({}),
}
